import Button from "@material-ui/core/Button";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import DoneAll from "@material-ui/icons/DoneAll";
import React, { Component } from "react";
import { baseColors } from "../../baseStyles";
import { updateStateEmployee } from "../../general_functions/employeeFunctions";
import { formatDate, privilegeChecker } from "../../general_functions/general";
import Simpletable from "../simpleTable";
import AlertDialogSlide from '../AlertDialogSlide';


export default class AllUsers extends Component {

  constructor(props){
    super(props);
    this.state = { user: "", state: 0, open: false, clearState: 'no' }
  }

  // componentWillMount() {
  //   let { users } = this.props;
  //   this.setState({ users });
  // }

  tableHeaderHandler() {
    return (
      <TableRow key={Math.random().toString(36)}>
        <TableCell component="th" scope="row">
          NO
        </TableCell>
        <TableCell numeric>Username</TableCell>
        <TableCell numeric>Email</TableCell>
        <TableCell numeric>State</TableCell>
      </TableRow>
    );
  }

  employeeActiveHandler(user, state) {
    // if (state == 3) {
    this.setState({open: true, username: user.username, state });
    // }
  }

  handleAgrement = (open, clearState) => {
    this.setState({ open, clearState});

    let { username, state} = this.state;
    let data = {
      username,
      state,
    };

    if (clearState === 'yes')
      updateStateEmployee(data, res => {
        if (res) {
          this.updateIconButtonHandler(data);
          this.props.handleSnackbar(
            "user updated"
          );
        } else {
          this.props.handleSnackbar(
            "Something whent Wrong!"
          );
        }
      });
  }
  // updateIconButtonHandler(data) {
  //   console.log(data);
  //   let { users } = this.props;
  //   let temp = [];
  //   for (let i = 0; i < users.length; i++) {
  //     if (users[i].state != 3)
  //       if (data.userName == users[i].userName){
  //         users[i].state = data.state;
  //         this.setState({ users });
  //         break;
  //       }
  //   }
  // }

  updateIconButtonHandler(data) {
    this.props.users.map((user, index) => {
      if (user.state != 3)
        if (data.username == user.username) user.state = data.state;
    });
  }

  employeeActivateBtnHandler(user) {
    let { state } = user;
    switch (state) {
      case 1:
        return (
          <Button
            onClick={() => {
              this.employeeActiveHandler(user, 2);
            }}
            mini
            variant="fab"
            color="primary"
            aria-label="check"
          >
            <Check />
          </Button>
        );
      case 2:
        return (
          <Button
            onClick={() => {
              this.employeeActiveHandler(user, 3);
            }}
            aria-label="Ass"
            mini
            variant="fab"
            color="secondary"
            aria-label="close"
          >
            <DoneAll />
          </Button>
        );
      case 3:
        return (
          <Button
            onClick={() => {
              this.employeeActiveHandler(user, 1);
            }}
            aria-label="Ass"
            mini
            variant="fab"
            color="secondary"
            aria-label="close"
          >
            <Close />
          </Button>
        );
      default:
        return null;
    }
  }

  tableRowHandler() {
    let { users } = this.props;
    let tableRows = [];
    if (users) {
      tableRows = users.map((user, index) => {
        if (user.state != 3)
          return (
            <TableRow key={Math.random().toString(36)}>
              <TableCell component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell numeric>{user.username}</TableCell>
              <TableCell numeric>{user.email}</TableCell>
              <TableCell>{this.employeeActivateBtnHandler(user)}</TableCell>
            </TableRow>
          );
      });
      return tableRows;
    }
  }

  render() {
    return (
      <div style={{ padding: "0 1em" }}>
        <div>
          <h3 style={{
            color: baseColors.bgBlue,
            paddingTop: 24}}>All Users</h3>
        </div>
        <br />

        <Simpletable
          tableHeaderHandler={this.tableHeaderHandler()}
          tableRowHandler={this.tableRowHandler()}
        />
        <AlertDialogSlide
          formTitle={"Are you sure you want to change state of the use?"}
          open={this.state.open}
          handleAgrement={(open, clearState ) => {
            this.handleAgrement(open, clearState);
          }}
          />
      </div>
    );
  }
}

const styles = {
  root: {
    width: "100%",
    marginTop: 8,
    overflowX: "auto",
    overflowY: "scroll"
  },
  table: {
    minWidth: 700
  }
};
